import { render } from "./eosrc-card.vue?vue&type=template&id=fede57f0"
import script from "./eosrc-card.vue?vue&type=script&setup=true&lang=js"
export * from "./eosrc-card.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/e-grid/eosrc-card/eosrc-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fede57f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fede57f0', __exports__)) {
    api.reload('fede57f0', __exports__)
  }
  
  module.hot.accept("./eosrc-card.vue?vue&type=template&id=fede57f0", () => {
    api.rerender('fede57f0', render)
  })

}


export default __exports__